import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ScanLine } from 'lucide-react';
import packageJson from '../../../package.json';

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const appVersion = packageJson.version;

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Hide Navbar on mobile search page — it has its own centered logo
    const isSearchPage = location.pathname === '/' || location.pathname === '/traceability' || location.pathname === '/traceability/search';
    if (isMobile && isSearchPage) {
        return null;
    }

    return (
        <div style={{ 
            backgroundColor: '#FFFFFF', 
            borderBottom: '1.35px solid #E2E8F0', 
            padding: isMobile ? '16px' : '16px 40px',
            height: '69px',
            display: 'flex',
            alignItems: 'center',
            position: 'sticky',
            top: 0,
            zIndex: 100,
            fontFamily: "'Poppins', sans-serif"
        }}>
            <div 
                style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}
                onClick={() => navigate('/')}
            >
                <ScanLine size={28} color="#071422" />
                <span style={{ fontSize: '20px', fontWeight: '600', color: '#071422' }}>
                    Syn<span style={{ color: '#02C170' }}>Trace</span>
                </span>
            </div>
            {appVersion && (
                <div
                    style={{
                        marginLeft: 'auto',
                        color: '#62748E',
                        fontSize: isMobile ? '12px' : '13px',
                        fontWeight: 500,
                        lineHeight: 1
                    }}
                >
                    App Version - {appVersion}
                </div>
            )}
        </div>
    );
};

export default Navbar;
